import { combineReducers } from 'redux'

import apiCallerReducer, { NAME as apiCaller } from './apiCallerReducer'
import costObjectsReducer, { NAME as costObjects } from './costObjectsReducer.js'
import creditRequestQuotesReducer, {
  NAME as creditRequestQuotes,
} from './creditRequestQuotesReducer'
import customerReducer, { NAME as customer } from './customerReducer.js'
import customersReducer, { NAME as customers } from './customersReducer.js'
import deviceOrderReducer, { NAME as deviceOrder } from './deviceOrderReducer.js'
import deviceOrdersReducer, { NAME as deviceOrders } from './deviceOrdersReducer.js'
import devicePolicyReducer, { NAME as devicePolicy } from './devicePolicyReducer.js'
import ecomOrderReducer, { NAME as ecomOrder } from './ecomOrderReducer'
import i18nReducer, { NAME as i18n } from './i18nReducer.js'
import newCustomerReducer, { NAME as newCustomer } from './newCustomerReducer.js'
import popupReducer, { NAME as popup } from './popupReducer'
import shopOrderReducer, { NAME as shopOrder } from './shopOrderReducer'
import shopOrdersReducer, { NAME as shopOrders } from './shopOrdersReducer'
import shopProductsReducer, { NAME as shopProducts } from './shopProductsReducer'
import shopProgressReducer, { NAME as shopProgress } from './shopProgressReducer'
import shopQuotesReducer, { NAME as shopQuotes } from './shopQuotesReducer'
import subscriptionOrderReducer, { NAME as subscriptionOrder } from './subscriptionOrderReducer.js'

export default combineReducers({
  [i18n]: i18nReducer,
  [customers]: customersReducer,
  [customer]: customerReducer,
  [costObjects]: costObjectsReducer,
  [newCustomer]: newCustomerReducer,
  [subscriptionOrder]: subscriptionOrderReducer,
  [deviceOrders]: deviceOrdersReducer,
  [deviceOrder]: deviceOrderReducer,
  [devicePolicy]: devicePolicyReducer,
  [popup]: popupReducer,
  [shopProducts]: shopProductsReducer,
  [shopProgress]: shopProgressReducer,
  [shopOrders]: shopOrdersReducer,
  [shopOrder]: shopOrderReducer,
  [shopQuotes]: shopQuotesReducer,
  [ecomOrder]: ecomOrderReducer,
  [apiCaller]: apiCallerReducer,
  [creditRequestQuotes]: creditRequestQuotesReducer,
})
